import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface Currency {
  code: string;
  symbol: string;
  name: string;
  rate: number; // Conversion rate from USD
}

export const CURRENCIES: Currency[] = [
  { code: 'USD', symbol: '$', name: 'US Dollar', rate: 1 },
  { code: 'EUR', symbol: '€', name: 'Euro', rate: 0.92 },
  { code: 'GBP', symbol: '£', name: 'British Pound', rate: 0.79 },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen', rate: 149.50 },
];

interface CurrencyStore {
  selectedCurrency: Currency;
  setSelectedCurrency: (currency: Currency) => void;
  convertPrice: (amount: number, fromCurrency: string) => number;
  formatPrice: (amount: number, fromCurrency: string) => string;
}

export const useCurrencyStore = create<CurrencyStore>()(
  persist(
    (set, get) => ({
      selectedCurrency: CURRENCIES[0], // USD as default

      setSelectedCurrency: (currency) => set({ selectedCurrency: currency }),

      convertPrice: (amount, fromCurrency) => {
        const { selectedCurrency } = get();
        
        // Find the source currency rate
        const sourceCurrency = CURRENCIES.find(c => c.code === fromCurrency);
        const sourceRate = sourceCurrency?.rate || 1;
        
        // Convert to USD first, then to target currency
        const amountInUSD = amount / sourceRate;
        const convertedAmount = amountInUSD * selectedCurrency.rate;
        
        return convertedAmount;
      },

      formatPrice: (amount, fromCurrency) => {
        const { selectedCurrency } = get();
        const convertedAmount = get().convertPrice(amount, fromCurrency);
        
        return `${selectedCurrency.symbol}${convertedAmount.toFixed(2)}`;
      },
    }),
    {
      name: 'currency-preference',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
